module.exports = __webpack_public_path__ + "img/rose-1.96eb2ac7.png";